export default __webpack_public_path__ + "static/media/ppub.f1f97ad0.svg";